import exclamationOrangeIcon from "data/icons/exclamation-orange.svg";
import checkGreen from "data/icons/check-green.svg";
import pending from "data/icons/pending.svg";
import expired from "data/icons/expired.svg";
import dotGray from "data/icons/dot-gray.svg";

export const statusTabs = [
  {
    key: "expiring",
    label: "Expiring",
    icon: (
      <img
        alt=""
        src={ exclamationOrangeIcon }
        style={ { height: 15, margin: "0 -5px -2px 5px" } }
      />
    ),
  },
  {
    key: "active",
    label: "Active",
    icon: (
      <img
        alt=""
        src={ checkGreen }
        style={ { height: 15, margin: "0 -5px -2px 5px" } }
      />
    ),
  },
  {
    key: "pending",
    label: "Pending",
    icon: (
      <img
        alt=""
        src={ pending }
        style={ { height: 15, margin: "0 -5px -2px 5px" } }
      />
    ),
  },
  {
    key: "expired",
    label: "Expired",
    icon: (
      <img
        alt=""
        src={ expired }
        style={ { height: 15, margin: "0 -5px -2px 5px" } }
      />
    ),
  },
  {
    key: "",
    label: "All",
    icon: (
      <img
        alt=""
        src={ dotGray }
        style={ { height: 10, margin: "0 -5px 0px 5px" } }
      />
    ),
  },
];
